export interface PageViewSettingsPayload {
  filters?: Record<string, unknown>;
  sort?: Record<string, unknown>;
  projectSettings?: Record<string, unknown>;
  [key: string]: unknown;
}

export function pageViewSettingsEqual(
  left: PageViewSettingsPayload,
  right: PageViewSettingsPayload,
): boolean {
  return (
    JSON.stringify(sortPageViewSettings(normalizeProjectId(left))) ===
    JSON.stringify(sortPageViewSettings(normalizeProjectId(right)))
  );
}

function normalizeProjectId(settings: PageViewSettingsPayload) {
  const projectSettings = settings.projectSettings;
  if (!projectSettings || typeof projectSettings.projectId !== "string") {
    return settings;
  }

  let projectId = projectSettings.projectId;
  for (let attempt = 0; attempt < 3; attempt += 1) {
    const decoded = decodeURIComponent(projectId);
    if (decoded === projectId) break;
    projectId = decoded;
  }

  return {
    ...settings,
    projectSettings: { ...projectSettings, projectId },
  };
}

function sortPageViewSettings(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(sortPageViewSettings);
  if (!value || typeof value !== "object") return value;

  return Object.keys(value as Record<string, unknown>)
    .sort()
    .reduce<Record<string, unknown>>((result, key) => {
      result[key] = sortPageViewSettings(
        (value as Record<string, unknown>)[key],
      );
      return result;
    }, {});
}
